export default __webpack_public_path__ + "static/media/10.48334195.png";